<template>
  <div class="campus-list" data-test="base-campus-list">
    <div class="vlist">
      <empty-page :show="list.length === 0" tips="还没有校区哦~"></empty-page>
      <div
        class="campus-wrapper"
        :class="{ disable: item.enabled === 0 }"
        v-for="item in list"
        :key="item.id"
      >
        <!-- <img
          class="item-photo"
          :src="getLogoImageUrl(item)"
          alt=""
        /> -->
        <div class="item-photo">
          <van-icon name="xiaoqu1" class-prefix="vxs-icon" />
        </div>
        <div class="item-name van-ellipsis">
          {{ item.name }}
        </div>
        <div class="status-btns">
          <span class="default-tag" v-if="item.isDefault && item.enabled !== 0">默认</span>
          <span class="non-enable" v-if="item.enabled === 0">未启用</span>
        </div>
        <div class="item-edit">
          <van-button
            plain
            square round
            v-if="(item.enabled===0&&app.permission.op('enable_campus')) || (item.enabled===1&&app.permission.op('disable_campus')) || (!item.isDefault&&item.enabled !== 0) || app.permission.op('edit_campus')"
            type="default"
            size="small"
            class="item-btn"
            @click.stop="operate(item)"
            >操作</van-button
          >
          <!-- <van-button
            plain
            square round
            v-if="!app.teacher.user.admin && !item.isDefault && item.enabled !== 0"
            type="default"
            size="small"
            class="item-btn"
            @click.stop="setDefaultCampus(item)"
            >设为默认</van-button
          > -->
        </div>
      </div>
    </div>

    <template>
      <pageFooterBtn
        btnText="新增校区"
        @click="add"
        v-if="companyInfo.companyProduct.productStatus == 2 && canAdd && app.permission.op('add_campus')"
        data-test="base-campus-list-btn-add"
      />
      <pageFooterBtn
        btnText="校区扩容"
        @click="goto(2)"
        v-if="companyInfo.companyProduct.productStatus == 2 && !canAdd && app.permission.op('expansion_campus')"
        data-test="base-campus-list-btn-kuorong"
      />
      <pageFooterBtn
        btnText="新增校区"
        @click="tryAdd"
        v-if="companyInfo.companyProduct.productStatus == 1 && app.permission.op('add_campus')"
      />
    </template>
    <!-- 校区操作列表 -->
    <van-action-sheet 
      v-model="showOperatedSheet" 
      :actions="operationActions" 
      cancel-text="取消" 
      close-on-click-action 
      @cancel="showOperatedSheet=false"
      @select="onSelectOperation"/>
  </div>
</template>

<script>
import pageFooterBtn from "@x3/vue/comp/page-footer-btn.vue";
import emptyPage from "@teacher/components/empty-page.vue";
export default {
  name: "baseCampusList",
  components: { pageFooterBtn, emptyPage },
  computed: {
    ...Vuex.mapState(["companyInfo"]),
    operationActions () {
      let operationActions = [];
      let { enabled, isDefault } = this.currentOperatedItem;
      if (enabled === 0 && app.permission.op('enable_campus')) {
        operationActions.push({name: '启用校区', id: 1});
      }
      if (enabled === 1 && app.permission.op('disable_campus')) {
        operationActions.push({name: '停用校区', id: 1, color: 'var(--c3)'}); 
      }
      if (!isDefault&&enabled==1) {
        operationActions.push({name: '设为默认', id: 2});
      }
      if (app.permission.op('edit_campus')) {
        operationActions.push({name: '编辑校区', id: 3});
      }
      return operationActions;
    }
  },
  data() {
    return {
      pageTitle: "校区管理",
      list: [],
      user: app.teacher.user,
      canAdd: false,
      currentOperatedItem: {},
      showOperatedSheet: false,
    };
  },
  methods: {
    render() {
      this.showLoading();
      Promise.all([this.$api.getCampusList({
        type: 2
      }), this.$api.checkAddCampus()]).then(
        ([res, addRes]) => {
          vant.Toast.clear();
          if (res.code === 200) {
            this.list = res.data;
          } else {
            this.$toast.fail(res.msg);
          }

          if (addRes.code == 200) {
            this.canAdd = true;
          } else {
            this.canAdd = false;
          }
        }
      );
    },
    toEditCampus(item) {
      this.$router.push(`/baseCampusAdd?type=edit&id=${item.id}`);
    },
    add() {
      this.$router.push("/baseCampusAdd?type=add");
    },
    //试用机构增加校区
    tryAdd() {
      if (this.canAdd) {
        this.add();
      } else {
        this.$dialog({
          message: "试用期间不能添加新校区，去开通服务吧",
          showCancelButton: true,
          confirmButtonText: "立即开通",
        }).then(() => {
          this.goto(0);
        });
      }
    },
    setDefaultCampus(item) {
      this.$dialog
        .confirm({
          title: "提示",
          message: `是否设置 【${item.name}】为默认校区`,
        })
        .then(() => {
          this.$api
            .updateDefaultCampus({
              campusId: item.id,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$toast.success("设置成功");
                app.teacher.refreshTo({
                  path: "/baseCampusList",
                  replace: true,
                });
              }
            });
        })
        .catch(() => {});
    },
    /**
     * 跳转不同情况的机构收费
     * type：开通类型, 0 开通 1续费 2扩容
     */
    goto(type) {
      app.teacher.gotoOpenBuy({
        selfType: type
      })
    },
    operate (item) {
      this.currentOperatedItem = item;
      this.showOperatedSheet = true;
    },
    onSelectOperation (v) {
      let item = this.currentOperatedItem;
      switch (v.id) {
        case 1: this.changeCampusEnableStatus(item);
          break;
        case 2: this.setDefaultCampus(item);
          break;
        case 3: this.toEditCampus(item);
          break;
      }
    },
    // 修改校区状态
    changeCampusEnableStatus (item) {
      let { enabled, id: campusId } = item
      let confirmMsg = '即将启用该校区，请确认';
      if (enabled === 1) {
        confirmMsg = `即将停用该校区，请确认<br/>校区停用后，校区下的班级将不能<br/>进行排课、点名、收费、商城上架等操作。`
      }
      // 启用/停用确认
      this.$dialog
        .confirm({
          title: "提示",
          message: confirmMsg,
        })
        .then(() => {
          this.$api
            .updateCampusStatus({
              campusEnabled: enabled ? 0 : 1,
              campusIds: [campusId],
            })
            .then((res) => {
              // 启用/停用成功
              if (res.code == 200) {
                app.teacher.refreshTo({
                  path: "/baseCampusList",
                  replace: true,
                });
              }
              // 机构未开通
              if (res.code === 810000002) {
                this.$dialog({
                  message: "试用期间，不能启用多个校区",
                  showCancelButton: true,
                  confirmButtonText: "立即开通",
                }).then(() => {
                  this.goto(0);
                });               
              }
              // 机构校区容量不够
              if (res.code === 810000003) {
                this.$dialog({
                  message: "启用失败，校区容量不足。",
                  showCancelButton: true,
                  confirmButtonText: "校区扩容",
                }).then(() => {
                  this.goto(2);
                });               
              }
            });
        })
        .catch(() => {});
    },
    // getLogoImageUrl (item) {
    //   return (item.logoImage && item.logoImage.url) || 
    //         'https://cdn01.xiaogj.com/uploads/x3/assets/img/default/s-01.png';
    // }
  },
  created() {
    this.render();
    this.$onBus("campus-list-update", () => {
      this.render();
    });
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.campus-list {
  display: flex;
  flex-direction: column;
}
.vlist {
  flex: 1;
  position: relative;
  background: var(--g1);
  overflow-y: auto;
  font-size: var(--fs-md);
  .campus-wrapper {
    display: flex;
    align-items: center;
    padding-right: calc(var(--w) * 76);
    height: calc(var(--w) * 72);
    line-height: calc(var(--w) * 72);
    background-color: var(--white);
    position: relative;
    &.disable {
      .item-photo {
        opacity: 0.6;
      }
      .item-name {
        opacity: 0.6;
      }
    }
    .item-photo {
      // margin: calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16);
      // width: calc(var(--w) * 40);
      // height: calc(var(--w) * 40);
      // border-radius: 50%;
      // background: var(--g4);
      margin: calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16) calc(var(--gap) * 16);
      width: calc(var(--w) * 40);
      height: calc(var(--w) * 40);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: rgba(var(--c1-rgb), 0.12);
      > i {
        color: var(--c1);
        font-size: var(--fs-ex1);
      }
    }
    .item-name {
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
      color: var(--g8);
      padding-right: calc(var(--gap) * 8);
    }
    .default-tag {
      display: inline-block;
      margin-right: calc(var(--gap) * 8);
      padding: 0 calc(var(--gap) * 8);
      color: var(--c1);
      width: auto;
      font-size:var(--fs-md);
      line-height:var(--lh-md);
      text-align: center;
      border-radius: var(--radius-md);
      white-space: nowrap;
      background: rgba(var(--c1-rgb), 0.1);
    }
    .non-enable{
      padding-right: calc(var(--gap) * 8);
      white-space: nowrap;
      color: var(--c4);
    }
    .item-edit {
      position: absolute;
      top: 0;
      bottom: 0;
      right: calc(var(--gap) * 16);
      .item-btn {
        height: calc(var(--w) * 28);
        min-width: calc(var(--w) * 60);
        vertical-align: super;
      }
    }
    &:not(:last-child)::after {
      position: absolute;
      content: " ";
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 64px;
      border-bottom: 1px solid var(--g3);
      transform: scaleY(0.5);
    }
  }
}
</style>